module.exports = __webpack_public_path__ + "static/img/qrcode2.b36c2b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/qrcode2.png
// module id = 5zCA
// module chunks = 0